import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useYouTube } from '../../../context/YouTubeContext';
import LiveSection_Conditional from '../LiveSection_Conditional';
import LatestMessage_Dynamic from '../LatestMessage_Dynamic';

/**
 * Bloc « Vidéo & Direct » de l'accueil : bandeau live conditionnel + dernière
 * vidéo/message YouTube. Extrait de HomeScreen, autonome (useYouTube).
 */
export default function VideoLiveSection() {
  const navigate = useNavigate();
  const { latestVideo, liveStatus, scheduledLive, loading: youtubeLoading } = useYouTube();

  const handleWatchVideo = useCallback(() => {
    if (latestVideo?.videoId) window.open(`https://www.youtube.com/watch?v=${latestVideo.videoId}`, '_blank');
    else navigate('/watch');
  }, [latestVideo, navigate]);

  const handleWatchLive = useCallback(() => {
    if (liveStatus?.live_videoId) window.open(`https://www.youtube.com/watch?v=${liveStatus.live_videoId}`, '_blank');
    else navigate('/watch');
  }, [liveStatus, navigate]);

  return (
    <>
      <LiveSection_Conditional
        isLive={liveStatus?.live_status}
        liveData={liveStatus}
        scheduledLive={scheduledLive}
        onWatchLive={handleWatchLive}
        loading={youtubeLoading}
      />
      <LatestMessage_Dynamic
        latestVideo={latestVideo}
        onWatch={handleWatchVideo}
        loading={youtubeLoading}
      />
    </>
  );
}
